const pad = (n) => String(n).padStart(2, '0');

// Follow-up dates are stored at 12:00 UTC so the calendar day never shifts with timezone.
export const toDueISO = (day) => new Date(`${day}T12:00:00Z`).toISOString();

export const dueDay = (iso) => (iso || '').slice(0, 10);

export const todayStr = () => {
  const n = new Date();
  return `${n.getFullYear()}-${pad(n.getMonth() + 1)}-${pad(n.getDate())}`;
};

export const dueBucket = (iso) => {
  const d = dueDay(iso);
  const t = todayStr();
  if (d < t) return 'overdue';
  if (d === t) return 'today';
  return 'upcoming';
};

export const formatDue = (iso) => {
  const [y, m, d] = dueDay(iso).split('-').map(Number);
  if (!y) return '';
  return new Date(y, m - 1, d).toLocaleDateString();
};